import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import styled from 'styled-components';

type CustomizedTypographyProps = {
  error?: boolean;
};
export const Wrapper = styled.div``;

export const CustomizedDialogTitle = styled(DialogTitle)`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

export const CustomizedDialogContent = styled(DialogContent)`
  padding: 5px 16px;
  padding-top: 5px !important;
  margin-bottom: 20px;
`;

export const CustomizedWarningAmberIcon = styled(WarningAmberIcon)`
  color: #f44336;
`;

export const CustomizedTypography = styled(Typography)<CustomizedTypographyProps>`
  color: ${props => props.error && '#f44336'};
`;

export const CustomizedDialog = styled(Dialog)``;
